import type { ComponentsTranslations } from './components.translations.pl.ts';
import { processTimerTranslations } from './processTimer/processTimer.translation.en.ts';
import { tableTranslations } from './table/table.translations.en.ts';

export const componentsTranslations: ComponentsTranslations = {
  table: tableTranslations,
  loader: {
    loading: 'Loading...',
  },
  narrator: {
    disable: 'Turn off the narrator',
    enable: 'Turn on the narrator',
  },
  processTimer: processTimerTranslations,
  slider: {
    ariaLabel: 'Choose a value on the scale',
  },
  textArea: {
    characterCount: '{{current}}/{{max}} characters',
  },
};
